var map = {
	"./favicon": "./app/javascript/images/favicon.png",
	"./favicon.ico": "./app/javascript/images/favicon.ico",
	"./favicon.png": "./app/javascript/images/favicon.png",
	"./icons/checkmark": "./app/javascript/images/icons/checkmark.svg",
	"./icons/checkmark.svg": "./app/javascript/images/icons/checkmark.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/javascript/images sync recursive ^\\.\\/.*$";